export default __webpack_public_path__ + "media/titles/title_2_locale_fr-b3f04424.png";